
import React from "react";
import Slider from "react-slick";
import { Card, CardContent, CardMedia, Typography } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './slider.css';

const instruction1 = `${process.env.PUBLIC_URL}/inspection-instruction/selfie-1.png`;
const instruction2 = `${process.env.PUBLIC_URL}/inspection-instruction/light.png`;
const instruction3 = `${process.env.PUBLIC_URL}/inspection-instruction/space-around.png`;
const instruction4 = `${process.env.PUBLIC_URL}/inspection-instruction/wash-car.png`;
const instruction5 = `${process.env.PUBLIC_URL}/inspection-instruction/car-reflection.png`;
const instruction6 = `${process.env.PUBLIC_URL}/inspection-instruction/network.png`;

const InstructionSlider = ({ setLastSlide }) => {
    const settings = {
        dots: true,
        // infinite: true, // Allows the slider to loop back to the beginning
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,           // Enables automatic sliding
        autoplaySpeed: 2000,      // Set to 2000ms (2 seconds)
        afterChange: (current) => {
            console.log("current",current);
            
            if (current === instructionSlides.length - 1) {
                console.log("here", instructionSlides.length);

                setLastSlide(false)
            }
        }
    };

    const instructionSlides = [
        // {
        //     image: instruction1,
        //     title: "Rotate phone horizontally",
        //     description: "Turn direction of your phone horizontally. Make sure ..."
        // },
        {
            image: instruction2,
            title: "Source of light",
            description: "Ensure there is ample natural light in the area for a clear image."
        },
        // {
        //     image: instruction3,
        //     title: "Space around the car",
        //     description: "Maintain at least 150 cm around the car for 360° video capture."
        // },
        // {
        //     image: instruction4,
        //     title: "Car should be washed",
        //     description: "Before the inspection, wash your car to ensure a high-quality capture"
        // },
        // {
        //     image: instruction5,
        //     title: "Avoid reflection",
        //     description: "Make sure to avoid reflections or shadows from any other objects."
        // },
        {
            image: instruction6,
            title: "Network requirements",
            description: "A min upload speed of 1 Mbps is required for real-time image uploads "
        },
    ];
    //display:"flex",alignItems:"center",justifyContent:"center" 

    return (
        <div style={{ width: '85%', maxWidth: '1200px', margin: '0 auto' }} >
            <Slider {...settings}>
                {instructionSlides.map((slide, index) => (
                    <div key={index} className="slick-card">
                        <Card sx={{ padding: "0rem", backgroundColor: "#fff", }} className="card-img-div">
                            <CardMedia
                                component="img"
                                alt={slide.title}
                                // height="300"
                                className="slider-card-media"
                                image={slide.image}
                            />
                            <CardContent sx={{ padding: "1rem" }}>
                                <Typography gutterBottom variant="h6" component="div">
                                    {slide.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {slide.description}
                                </Typography>
                            </CardContent>
                        </Card>
                    </div>
                ))}
            </Slider>
        </div>
    );
};
export default InstructionSlider;
